<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h1 class="text-white">City Office</h1>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="/city-office">City Office</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="core-value ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">

        <div class="table-responsive mt-2">
          <table class="table table-bordered table-hover table--1">
            <thead>
              <tr>
                <th width="15%">Location</th>
                <th width="55%">Office Address </th>
                <th width="30%">Marketing Executive</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Gondia Office </td>
                <td>Near new Bus Stand Balaghat Road, Marartoli Gondia-441604.</td>
                <td>Ankush Rahulkar<br><a href="tel:8380011038">8380011038</a> /<a href="tel:8421017062"> 8421017062
                  </a></td>
              </tr>
              <tr>
                <td>Bhandara Office </td>
                <td>Turaskar Complex, Rajiv Gandhi Chowk, Bhandara-441904.</td>
                <td>Shubham Bhelkar<br><a href="tel:8380011041"> 8380011041</a> /<a href="tel:9970654024">
                    9970654024</a></td>
              </tr>
              <tr>
                <td>Chandrapur Office </td>
                <td> 2nd Floor, Sai Heritage Building Old Warora Naka, Chandrapur- 442401</td>
                <td>Rahul Gedam <br><a href="tel:7887886728">7887886728</a></td>
              </tr>
              <tr>
                <td>Wardha Office </td>
                <td>Mehar Complex, Shop No. 3, 1st Floor, Beside Shivparvati Marriige Hall, Arvi Road, Wardha - 442001.
                </td>
                <!-- <td>Nikhil Dharmari<br><a href="tel:8380012006">8380012006</a> /<a href="tel:9518976279"> 9518976279</a></td> -->
              </tr>
              <tr>
                <td>Akola Office </td>
                <td> 19,Harsh Sankul Complex, Opposite RLT Science College, Beside Navneet Book Store &amp; Stationers,
                  Civil Line road Akola - 444001</td>
                <!-- <td>Chetan Dhoble<br><a href="tel:8380013017"> 8380013017</a> /<a href="tel:8237785351"> 8237785351</a></td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
